<template>
	<el-container class="login-wrap">
	  <div class="login-wrap-content">
		  <!-- <img src="../assets/images/dark/login/img_login_zhikong.png" alt=""> -->
		  <div class="flex1 login-left"></div>
		  <div class="login-wrap-login">
			  <div class="title">
				  医学影像质量控制平台
			  </div>
			  <div class="btn cur" @click="workbench">
				  开始使用
			  </div>
			  <div class="fz28">
				  还没有帐号 <span class="dodgerBlue cur" @click="register">马上注册</span>
			  </div>
		  </div>
	  </div>
	   <footers></footers>
	</el-container>
</template>

<script>
	import { mapState } from 'vuex'
	import Footers from "@/components/Common/footers"
	export default{
		data(){
			return {
				url: '',
				basicUrl:'',
				homeUrl:'',
				encodeUrl:'',
				name:'',
				selectRoleClick:false,
			}
		},
		components: {
			Footers
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['versionNo']),
			...Vuex.mapState('login', ['dynamicValidateForm','selectRole']),
			...Vuex.mapState('admin', ['rolesList','listParameter'])
		},
		created(){
			this.basicUrl = process.env.VUE_APP_DOMAIN_HREF;
			this.homeUrl = process.env.VUE_APP_HOME_URL;
			this.encodeUrl = encodeURIComponent(this.homeUrl);
		},
		methods:{
			// 注册
			register(){
				location.href = `${this.basicUrl}/register?callback_url=${this.encodeUrl}`;
			},
			// 开始使用
			workbench(){
				location.href = `${this.basicUrl}/login?callback_url=${this.encodeUrl}`;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	.login-wrap .el-footer{
		height: 40px !important;
		line-height: 40px !important;
		background-color: transparent !important;
	}
	.login-wrap{
		@include bg-color(workListBg);
		flex: 1;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}
	.login-left{
		background: url(../assets/images/dark/login/img_login_zhikong.png) no-repeat 0/cover;
	}
</style>
